export default __webpack_public_path__ + "static/media/team-banner.8b07ef02.png";